import React from 'react';
import { PresignedImage } from '@/components/common/PresignedImage';
import { Image as ImageIcon } from 'lucide-react';

interface CarouselItemProps {
    photo: {
        photoId: string;
    };
}

export const CarouselItem: React.FC<CarouselItemProps> = ({ photo }) => {
    return (
        <div className="size-32 bg-zinc-100 rounded-lg border border-zinc-200 overflow-hidden flex items-center justify-center">
            {photo.photoId ? (
                <PresignedImage fileId={photo.photoId} className="size-full object-cover" />
            ) : (
                <ImageIcon className="size-8 text-zinc-400" />
            )}
        </div>
    );
};
